(function () {
  // Read gender from URL param, fall back to referrer
  const params = new URLSearchParams(window.location.search);
  let gender = params.get("gender");

  if (!gender) {
    const ref = (document.referrer || "").toLowerCase();
    if (ref.includes("women")) gender = "female";
    else if (ref.includes("men")) gender = "male";
  }

  if (!gender) return;

  // Hide the gallery immediately so the user never sees the wrong
  // initial scroll position. We'll reveal it as soon as we've
  // scrolled to the matching slide.
  const hideStyle = document.createElement("style");
  hideStyle.textContent =
    "slider-component { visibility: hidden !important; }";
  (document.head || document.documentElement).appendChild(hideStyle);

  // Safety net: always reveal after 1 second even if something goes wrong
  const safety = setTimeout(() => {
    if (hideStyle.parentNode) hideStyle.remove();
  }, 1000);

  function jumpToMatchingSlide() {
    const slides = document.querySelectorAll(
      "slider-component .slider__slide"
    );
    if (!slides.length) return false;

    for (const slide of slides) {
      const img = slide.querySelector("img");
      if (!img) continue;
      const alt = (img.getAttribute("alt") || "").toLowerCase();
      if (alt.includes(gender)) {
        slides.forEach((s) => s.classList.remove("is-active"));
        slide.classList.add("is-active");
        slide.scrollIntoView({ block: "start", behavior: "auto" });
        clearTimeout(safety);
        if (hideStyle.parentNode) hideStyle.remove();
        return true;
      }
    }
    return false;
  }

  // Poll on every frame until slider is in DOM, then jump and reveal
  let frames = 0;
  function poll() {
    frames++;
    if (jumpToMatchingSlide()) return;
    if (frames < 60) {
      requestAnimationFrame(poll);
    } else {
      clearTimeout(safety);
      if (hideStyle.parentNode) hideStyle.remove();
    }
  }

  requestAnimationFrame(poll);
})();